module.exports = __webpack_public_path__ + "img/small.b1426e59.jpg";